export default {"src":"/_next/static/media/packing.ed15b7d0.svg","height":160,"width":160};